import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { observeAndAnimate } from "./utils";
gsap.registerPlugin( DrawSVGPlugin );
gsap.registerPlugin( MorphSVGPlugin );
gsap.registerPlugin( SplitText );
gsap.registerPlugin( ScrollTrigger );
const hero = document.querySelector( ".hp-hero" );
if ( hero ) {
  // timeline for looping
  const tl = gsap.timeline( {
    paused: true,
    repeat: -1,
    defaults: { duration: 0.5, ease: "none" },
  } );

  // globe paths
  let globePaths = hero.querySelectorAll( "#globe-hp path:not(.traverser)" );
  globePaths = Array.from( globePaths ).slice( 0, 30 );
  // const paths = [];
  // globePaths.forEach((path, i) => {
  //   paths.push(path.getAttribute("d"));
  // });

  globePaths.forEach( ( path, i ) => {
    const dasharray = "0.85 13.64";
    const stroke = "#426ABE";
    const strokeWidth = 2.55;

    // const originalPath = paths[i];
    // const originalDashArray = path.getAttribute("stroke-dasharray");
    if ( i > 1 ) {
      const prevprev = globePaths[ i - 2 ];
      tl.to( prevprev, {
        strokeWidth: strokeWidth,
        duration: 0,
      } );
    }
    if ( i != 0 ) {
      // previous item here
      const prev = globePaths[ i - 1 ];
      const prevPath = prev.getAttribute( "d" );
      tl.to( prev, {
        stroke: stroke,
        strokeDasharray: dasharray,
        strokeWidth: 8,
        duration: 0,
      } );
    }

    // active element
    tl.to( path, {
      strokeDasharray: "none",
      strokeWidth: 10,
      stroke: "#C0FA9C",
      duration: 0.2,
      stagger: 0.15,
    } );

    if ( i != globePaths.length - 1 ) {
      // next item here
      const next = globePaths[ i + 1 ];
      tl.to(
        next,
        {
          stroke: stroke,
          strokeDasharray: dasharray,
          strokeWidth: 8,
          duration: 0.2,
        },
        "<"
      );
    }
  } );

  // move the ball first before doing globe animatino
  observeAndAnimate( ".top-ball", () => {
    console.log( "starting hp animations" );
    gsap.to( ".top-ball", {
      y: window.innerWidth >= 1024 ? 288 : 179,
      ease: "none",
      duration: 1,
      onComplete: () => {
        tl.play();
      },
    } );
  } );

  let headingIndex = 0;
  const headingElement = hero.querySelector( ".hero-text" );
  const isMobile = window.matchMedia( "(max-width: 767px)" ).matches;

  const isPrimary = headingIndex % 2 === 0;
  if ( isPrimary ) {
    headingElement.classList.add( "primary-heading" );
    if ( isMobile ) {
      headingElement.style.fontSize = "44px";
    }
  }

  let split = new SplitText( headingElement, { type: "words,lines" } );
  const timing = 4000;

  function animateHeading () {
    const words = split.words;

    gsap.to( words, {
      y: 100,
      opacity: 0,
      stagger: 0.012,
      duration: 0.25,
      onComplete: () => {
        headingIndex = ( headingIndex + 1 ) % headings.length;
        headingElement.innerHTML = headings[ headingIndex ];

        // Re-split text after content change
        split = new SplitText( headingElement, { type: "words,lines" } );
        const isPrimary = headingIndex % 2 === 0;

        headingElement.classList.toggle( "primary-heading", isPrimary );

        gsap.to( split.words, {
          color: isPrimary ? "#233866" : "#426ABE",
          duration: 0,
        } );

        // Apply 44px font-size only if primary heading on mobile
        if ( isMobile && isPrimary ) {
          headingElement.style.fontSize = "44px";
        } else {
          headingElement.style.fontSize = ""; // reset to default
        }

        gsap.fromTo(
          split.words,
          {
            y: 100,
            opacity: 0,
            stagger: 0.02,
            duration: 0.75,
          },
          {
            y: 0,
            opacity: 1,
          }
        );

        setTimeout( animateHeading, timing );
      },
    } );
  }



  // lime ball sticky animation
  const ball = document.querySelector( "#ball" );
  const parent = ball.parentNode;
  gsap.to( ball, {
    translateY: parent.clientHeight - ball.clientHeight - 165,
    // delay: 1,
    ease: "none",
    scrollTrigger: {
      trigger: parent,
      start: "top 20%",
      end: "bottom 80%",
      scrub: true,
    },
    onReverseComplete: () => {
      // hide the ball
      console.log( "onReverseComplete" );
      gsap.set( ball, {
        opacity: 0,
      } );
    },
    onStart: () => {
      // show the ball
      console.log( "onStart" );
      gsap.set( ball, {
        opacity: 1,
      } );
    },
  } );
  // Start headings animation
  setTimeout( animateHeading, timing );
}

// const traverser = hero.querySelector("#globe-hp .traverser");
// globePaths.forEach((path, i) => {
//   tl.to(traverser, { morphSVG: { shape: path, shapeIndex: "auto" } }, i * 0.5);
// });
// globePaths.forEach((path, i) => {
//   const d = MorphSVGPlugin.convertToPath(path);
//   tl.to(traverser, { morphSVG: path}, i * 0.5);
// });

// console.log("globePaths", globePaths);
// globePaths.forEach((path, i) => {
//   const d = path.getAttribute("d");
//   const stroke = path.getAttribute("stroke");
//   const strokeWidth = path.getAttribute("stroke-width");
//   const dashArray = path.getAttribute("stroke-dasharray");
//   tl.fromTo(
//     path,
//     {
//       strokeDasharray: dashArray,
//       strokeWidth: strokeWidth,
//       stroke: stroke,
//       duration: 0.05,
//     },
//     {
//       strokeDasharray: "none",
//       strokeWidth: 6,
//       stroke: "#C0FA9C",
//     }
//   );
// });
